import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import { icons } from "../../../../../../utils/icons"
import { FacebookCircularProgress } from "../facebookIndicator"
import { useStyles } from "./styles"
import Loader from "../../../../../../components/loader"
import { useTranslation } from "react-i18next"

const ScoreCard = (props: { loading: boolean; refresh: () => void, title: string; subtitle: string; value: number }) => {
  const styles = useStyles()
  const { t } = useTranslation()
  return (
    <Box sx={styles.container}>
      {
        !props.loading ? (
          <>
            <Box sx={styles.actionIndicator}>
              <Tooltip title={t('ToolTips.refresh')}>
                <IconButton
                  onClick={() => {
                    props.refresh()
                  }}
                >
                  {icons('refresh')}
                </IconButton>
              </Tooltip>
            </Box>

            <Box sx={styles.information}>
              <Typography sx={styles.title}>{props.title}</Typography>

              <Typography sx={styles.subTitle}>{props.subtitle}</Typography>
            </Box>

            <Box sx={styles.progress}><FacebookCircularProgress style={{ width: '100px', height: '100px' }} variant="determinate" value={props.value} /></Box>

          </>
        )
          :
          <Loader />
      }
    </Box>
  )
}

export { ScoreCard }
